/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2024 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import { useLayoutEffect, useState } from "react";

export const useLatestValue = <T extends any>(
  iterable: AsyncIterable<T>
): T | null => {
  const [latest, setLatest] = useState<T | null>(null);

  // layout effect in case first value from the iterable is synchronous.
  useLayoutEffect((): VoidFunction => {
    let cancelled = false;

    const observe = async (): Promise<void> => {
      for await (const value of iterable) {
        if (!cancelled) {
          setLatest(value);
        }
      }
    };

    observe();

    return (): void => {
      cancelled = true;
    };
  }, [iterable]);

  return latest;
};
